import React, { useState } from 'react';
import moment from 'moment';
import numeral from 'numeral';
import { Button } from 'antd';
import USER_EXAM_STATUS from '@achievable-me/tundra-wizard/userExamStatus';
import BURN_UP_CUTOFF from './burnUpCutoff';
import SCREEN from './screen';
import BurnUp from './BurnUp';

import styles from './styles.scss';
import GenericSummary from '../GenericSummary';

const ExamSummaryContents = (props) => {
  const { handleQueueNavigation, quizState } = props;
  const { userExam } = quizState;

  const [screen, setScreen] = useState(SCREEN.summary);
  if (screen === SCREEN.burnUp) {
    return (
      <BurnUp
        userExam={userExam}
        setScreen={setScreen}
        handleQueueNavigation={handleQueueNavigation}
      />
    );
  }

  const { exam, score, scoreSummary, startedAt, finishedAt } = userExam;
  const { allottedTimeMins } = exam;

  const summary = scoreSummary.map((summaryObj) => {
    const { examContentUuid, examContentName, correct, total } = summaryObj;
    return {
      key: examContentUuid,
      correct,
      total,
      name: examContentName,
    };
  });

  const examMomentStart = moment(startedAt);
  const examMomentFinish = moment(finishedAt);
  const minutesUsed = Math.floor(
    moment.duration(examMomentFinish - examMomentStart).asMinutes()
  );

  const showBurnUpChart = examMomentStart > moment(BURN_UP_CUTOFF);

  return (
    <GenericSummary
      title="Mock exam"
      userExam={userExam}
      product={exam.product}
      score={numeral(score).format('0%')}
      summary={summary}
      extra={
        <div className={styles.examSummaryExtra}>
          <div>Started: {examMomentStart.format('MMMM Do, h:mm a')}</div>
          <div>Finished: {examMomentFinish.format('MMMM Do, h:mm a')}</div>
          <div>
            {minutesUsed} of {allottedTimeMins} mins
          </div>
          {showBurnUpChart && (
            <Button onClick={() => setScreen(SCREEN.burnUp)}>
              View burn up chart (beta)
            </Button>
          )}
        </div>
      }
    />
  );
};

const ExamInstructions = (props) => {
  const { quizState } = props;
  const { userExam } = quizState;
  const { exam } = userExam;
  const { allottedTimeMins, numQuestions } = exam;

  return (
    <div className={styles.layoutInner}>
      <div className={styles.ready}>
        Mock exam
        <br />
        <b>{exam.product.name}</b>
        <br />
        <br />
        {allottedTimeMins} minutes
        <br />
        {numQuestions} questions
        <br />
      </div>
      <div className={styles.readyInfo}>
        The timer will count down to the allotted time as a guide, but you will be allowed
        to finish even if it takes longer. Your responses are stored as you proceed, so if
        you lose your internet connection, you can resume by refreshing the page or
        navigating from your dashboard. You can jump to a specific question by opening the
        menu in the top right. If you &apos;flag&apos; an item, it will display an
        indicator in that menu. Good luck!
        <div className={styles.copyright}>
          All rights reserved &copy;2016 - {new Date().getFullYear()} Achievable, Inc.
        </div>
      </div>
    </div>
  );
};
const ExamSummary = (props) => {
  const { handleQueueNavigation, quizState } = props;
  const { userExam } = quizState;
  const { status } = userExam;

  if (status === USER_EXAM_STATUS.finished) {
    return (
      <div className={styles.layoutInner}>
        <ExamSummaryContents
          quizState={quizState}
          handleQueueNavigation={handleQueueNavigation}
        />
      </div>
    );
  }

  return (
    <div className={styles.layout}>
      <ExamInstructions quizState={quizState} />
    </div>
  );
};

export default ExamSummary;
